export const listTypeInfo = {
  linkedList: [
    {id: null, name: '全部'},
    {id: 0, name: '待关联'},
    {id: 1, name: '已关联'},
  ],
  availableList: [
    {name: '全部', id: null},
    {name: '是', id: 1},
    {name: '空', id: -1},
  ],
}
export const tableLabel = [
  {label: '石化采购订单编号', param: 'orderNo', align: 'center', width: '180', fixed: 'left'},
  {label: 'ERP订单号', param: 'erpNo', align: 'center', width: '120'},
  {label: '采购商名称', param: 'purchaseCompany', align: 'center', width: '180', tooltip: true},
  {
    label: '是否已关联',
    align: 'center',
    minWidth: 110,
    render(row) {
      const data = {
        0: '待关联',
        1: '已关联',
      };
      return data[row.linked];
    },
  },
  {
    label: '下单时间',
    param: 'submitTime',
    align: 'center',
    tooltip: true,
    hide: '2',
    width: '140'
  },
  {label: '要求到货时间', param: 'arriveTime', align: 'center', width: '140'},
  {
    label: '原材料订单',
    align: 'center',
    slot: 'petroMallOrderOrderList',
    width: 260,
  },
  {label: '备注', param: 'remark', align: 'center', width: '200', slot: 'remark', tooltip: true},
  // 是否现货: 0:没有现货；1：现货供应
  {
    label: '是否现货',
    align: 'center',
    minWidth: 140,
    render(row) {
      const data = {
        '1': '是',
        '-1': '空',
      };
      return data[String(row.available)];
    },
    slot: 'available'
  },
  {
    label: '结算方式', param: 'isDoC', align: 'center',
    render(row) {
      const data = {
        1: '货到付款',
        0: '款到发货',
      };
      return data[Number(row.isDoC)];
    },
  },
  {
    label: '订单类型', param: 'purchaseRequestType', align: 'center',
    render(row) {
      const data = {
        1: '标准',
        2: '寄售',
      };
      return data[Number(row.purchaseRequestType)];
    },
  },
  {label: '操作', param: '', align: 'center', slot: 'operate', fixed: 'right', width: '160'},
]

export const listQuery = {
  orderNo: null,
  erpNo: null,
  purchaseCompany: null,
  remark: null,
  available: null,
  linked: null,
  submitTime: null,
  arriveTime: null,
}

export const fieldList = [
  {label: '石化采购订单编号', type: 'input', value: 'orderNo',},
  {label: 'ERP订单号', type: 'input', value: 'erpNo',},
  {label: '采购商名称', type: 'input', value: 'purchaseCompany',},
  {
    label: '下单时间', value: 'submitTime',
    type: 'date',
    dateType: 'daterange',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    format: 'yyyy-MM-dd',
    defaultTime: ['00:00:00', '23:59:59'],
  },
  {
    label: '要求到货时间', value: 'arriveTime',
    type: 'date',
    dateType: 'daterange',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    format: 'yyyy-MM-dd',
    defaultTime: ['00:00:00', '23:59:59'],
  },
  {label: '备注', type: 'input', value: 'remark',},
  {label: '是否已关联', type: 'select', value: 'linked', list: 'linkedList'},
  {label: '是否现货', type: 'select', value: 'available', list: 'availableList',},
]

export const getPetroMallOrderOrderList = (row) => {
  const {petroMallOrderOrderList = [], petroMallOrderStockList = []} = row;
  const list = [...petroMallOrderOrderList, ...petroMallOrderStockList];
  return list;
};